import { BrowserRouter, Routes, Route } from "react-router-dom";
import FaceAttendance from "./page/faceattendance";
import Attendance from "./page/Attendance";
import "./App.css"
import Footer from "./component/footer";
import Holiday from "./page/holiday";


function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<FaceAttendance />} />
        <Route path="attendance" element={<Attendance />} />
         <Route path="holiday" element={<Holiday/>} />
    
      </Routes>
      <Footer/>
    </BrowserRouter>
  );
}

export default App;